<div>
   <app-dashboard-header></app-dashboard-header>
   <div class="border-top-none">
      <app-selected-client></app-selected-client>
   </div>
   <div class="container-fluid p-0">
      <!-- <div class="header-text-top"><P>APERCU GENERAL</P></div> -->
      <div class="border-top-none">
         <div class="header-text-top text-center fit-80 p-2">{{'Dashboard_OD0060' | translate}}</div>


         <div class="fit-80 dashboard-text">

            <p>{{'Dashboard_OD0061'| translate }}</p>
            <p>{{'Dashboard_OD0062'| translate}}</p>
            <p>{{'Dashboard_OD0063'| translate}}</p>
            <p>{{'Dashboard_OD0064'| translate}}</p>
            <p>{{'Dashboard_OD0185'| translate}}</p>


         </div>
         <div class="header-text-bottom fit-80 p-2">
            <P class="mb-0">{{'Dashboard_OD0065' | translate}}</P>
         </div>
      </div>

      <div class="table-responsive table-sm container-fluid border-top-none p-0" style="border-bottom: none;">

         <table class="table table-striped table-bordered table-md">
            <thead>
               <tr class="table-active">
                  <th scope="col">{{'Dashboard_OD0066' | translate}}</th>
                  <!-- <th scope="col" *ngIf="formsStatus == 'Success'"></th> -->
                  <th scope="col">{{'Dashboard_OD0067' | translate}}</th>
                  <th scope="col">{{'Dashboard_OD0068' | translate}}</th>
                  <th scope="col">{{'Dashboard_OD0069' | translate}}</th>
               </tr>
            </thead>
            <tbody>
               <tr *ngFor="let item of rowData">
                  <th scope="row" *ngIf="item.isFormVisible == 'true'">
                     <!-- *ngIf="isFormVisible == 'true'" -->
                     <span (click)="redirectToForms(item.Declaration,item.NoDeclaration)"
                        [ngClass]="{'disable-form':item.isDeclarationEnabled =='false',
                                    'enable' : item.isDeclarationEnabled == 'true','disable':item.status =='dashboard_form_status_OD0198'}">{{item.Declaration | translate}}
                        <span class="p-1 ">({{item.FormName}})</span></span>
                        <span class="p-1 float-right " style="cursor: pointer;" (click)="downloadPdf(item.FormName,item.NoDeclaration)"
                        *ngIf="item.status =='dashboard_form_status_OD0198' && item.FormName != '6' ">
                        <img class="img-styles float-right enable" src="https://img.icons8.com/officel/36/000000/pdf.png" /></span>
                  </th>

                  <!-- <td *ngIf="formsStatus == 'Success'" ><img (click)="downloadPdf($event)" class="img-styles" 
                  src="https://img.icons8.com/officel/36/000000/pdf.png"/></td> -->

                  <td *ngIf="item.isFormVisible == 'true'">{{ item.remplir}}</td>
                  <td *ngIf="item.isFormVisible == 'true'">{{ item.Date }}</td>
                  <td *ngIf="item.isFormVisible == 'true'" [ngClass]="{'status-completed':item.status=='dashboard_form_status_OD0198' ,
                  'status-active':item.status =='dashboard_form_status_OD0197',
                  'status-new':item.status =='dashboard_form_status_OD0196' }">{{ item.status |translate}}</td>
               </tr>
            </tbody>
         </table>
         <div class="p-1 text-center">
            <p *ngIf="submitError" class="error-message">{{'Submit_error_message_OD0207'|translate}}</p>
            <p *ngIf="downloadError" class="error-message">{{'Error_pdf_OD210'|translate}}</p>
         </div>
         <div class="m-2 float-right" [ngClass]="{'disable-form': isSubmitEnabled == true}">
            <app-dashboard-popup (callSubmit)="submitFormsData($event)" [isSubmitEnabled]=isSubmitEnabled>
            </app-dashboard-popup>
         </div>
      </div>

   </div>
   <app-footer></app-footer>
</div>


<ng-http-loader [entryComponent]="customSpinnerComponent"></ng-http-loader>